import type { Incident } from '../../incidents/types/incident.types'
import { formatClockTime } from '../utils/liveOpsAggregate'

interface IncidentsListProps {
  incidents: Incident[]
}

export function IncidentsList({ incidents }: IncidentsListProps): JSX.Element {
  return (
    <div className="rounded-xl border border-[#E5E7EB] bg-white">
      <div className="border-b border-[#E5E7EB] px-5 py-4">
        <h2 className="text-sm font-semibold text-gray-700">Incidents</h2>
      </div>
      <div className="divide-y divide-gray-100">
        {incidents.length === 0 ? (
          <p className="px-5 py-6 text-center text-sm text-gray-400">No incidents today</p>
        ) : (
          incidents.map((incident) => (
            <div key={incident.id} className="flex items-start justify-between gap-4 px-5 py-3">
              <div className="min-w-0">
                <p className="text-sm font-medium text-gray-800">{incident.title}</p>
                {incident.description && (
                  <p className="mt-0.5 text-xs text-gray-500">{incident.description}</p>
                )}
              </div>
              <div className="shrink-0 text-right">
                <p className="text-xs font-medium text-gray-500">{incident.source ?? 'system'}</p>
                <p className="text-[11px] text-gray-400">{formatClockTime(incident.created_at)}</p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  )
}
